import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import globalTranslations from '../../../../../i18n/globalTranslations';
import OrderCheckoutProduct from '../../../../../models/order/checkout/OrderCheckoutProduct';
import { modelOf } from '../../../../../prop-types';
import CheckoutStore from '../../../../../store/CheckoutStore';
import FormGroupField from '../../../../form/FormGroupField';

const CheckoutCartProductReference = ({
  checkoutStore,
  intl,
  onOrderUpdate,
  product,
  referenceField,
}) => {
  if (!referenceField || !referenceField.active) return null;

  const { cancelOrder } = checkoutStore;

  const handleChange = (e) => {
    cancelOrder();
    product.updateReferenceField(e.target.value);
  };

  // Field only enables validation on blur when value is truthy, so empty required
  // fields would never run notBlank unless we force shouldValidate here.
  const handleBlur = (_, field) => {
    if (field) {
      field.setShouldValidate(true);
    }
    onOrderUpdate({ withoutTimer: true });
  };

  const referenceLabel = intl.formatMessage(globalTranslations.referenceTitle);

  return (
    <div className="CheckoutCartProductReference">
      <FormGroupField
        label={referenceLabel}
        floatingLabel
        formName="checkout"
        field={referenceField}
        fieldName={referenceField.name}
        type={referenceField.type.toLowerCase()}
        placeholder={referenceLabel}
        onChange={handleChange}
        required={referenceField.required}
        onBlur={handleBlur}
        onFocus={cancelOrder}
      />
    </div>
  );
};

CheckoutCartProductReference.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
  product: modelOf(OrderCheckoutProduct).isRequired,
  referenceField: PropTypes.object,
};

export default injectIntl(
  inject('checkoutStore')(observer(CheckoutCartProductReference))
);
